import { render, staticRenderFns } from "./DialogConfirmFileExtension.vue?vue&type=template&id=a9996636&scoped=true"
import script from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogConfirmFileExtension.vue?vue&type=style&index=0&id=a9996636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9996636",
  null
  
)

export default component.exports